import { add, remove, has } from '../core';
export var keyboard = function (event, state, keycode) {
    if (has(state, 'disabled'))
        return state;
    if (event.keyCode.toString() !== keycode.toString())
        return state;
    switch (event.type) {
        case 'keydown':
            state = add(state, 'active');
            break;
        case 'keyup':
            state = remove(state, 'active');
            break;
    }
    return state;
};
export default keyboard;
